function readAdvertisingConfig(advertising) {
    if (!advertising || typeof advertising !== 'object' || Array.isArray(advertising)) {
        return null;
    }

    return Object.keys(advertising).length === 0 ? null : advertising;
}

export default readAdvertisingConfig;
